// removed by extract-text-webpack-plugin
module.exports = {"component":"src-components-DirectionsButton----DirectionsButton-module---component---2y7Ni"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DirectionsButton/DirectionsButton.module.scss
// module id = 180
// module chunks = 16192702802281 104101334113578